import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { username = "", password = "" } = location.state || {};

  const handleGoBackHome = () => {
    navigate("/");
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          p: 4,
          borderRadius: 2,
          maxWidth: 400,
        }}
      >
        <CheckCircleOutlineIcon
          sx={{
            fontSize: "64px",
            color: "#4caf50",
            mb: 2,
          }}
        />

        <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
          {t("Thank You")}!
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          {t(
            "Thank you for showing interest, our team will get back to you with more details. We have created a new FPO account on Farmapp below are the credentials"
          )}
          :
        </Typography>

        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          {t("Username")}: {username}
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          {t("Password")}: {password}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBackHome}
          sx={{ mt: 2, color: "white" }}
        >
          {t("Back to Home")}
        </Button>
      </Box>
    </Box>
  );
};

export default SuccessPage;
